import React from 'react';
import './Applications.css';
import AppScreen1 from '../assets/app-screenshots/1.jpeg';
import { useLanguage } from '../context/LanguageContext';

const upcomingSlots = [
  { id: 2 },
  { id: 3 },
  { id: 4 },
  { id: 5 },
  { id: 6 }
];

const Applications = ({ onNavigate }) => {
  const { t } = useLanguage();

  return (
    <section id="uygulamalar" className="apps-section">
      <div className="section-header">
        <div className="section-badge">
          <i className="fa-solid fa-layer-group"></i>
          <span>{t('apps.badge')}</span>
        </div>
        <h2 className="section-title">{t('apps.title')}</h2>
        <p className="section-subtitle">{t('apps.subtitle')}</p>
      </div>

      {/* Flagship App Card */}
      <div className="flagship-card">
        <div className="flagship-glow"></div>
        <div className="flagship-badge">
          <i className="fa-solid fa-star"></i>
          <span>{t('apps.flagshipBadge')}</span>
        </div>

        <div className="flagship-content">
          <div className="flagship-info">
            <h3 className="flagship-title">{t('apps.flagshipTitle')}</h3>
            <p className="flagship-desc">{t('apps.flagshipDesc')}</p>
            
            <div className="cross-platform-badge">
              <i className="fa-solid fa-laptop-code"></i>
              <span>{t('apps.crossBadge')}</span>
            </div>

            <div className="flagship-features">
              <div className="feature-item">
                <i className="fa-solid fa-desktop"></i>
                <div>
                  <strong>{t('apps.f1Title')}</strong>
                  <span>{t('apps.f1Desc')}</span>
                </div>
              </div>
              <div className="feature-item">
                <i className="fa-solid fa-heart-pulse"></i>
                <div>
                  <strong>{t('apps.f2Title')}</strong>
                  <span>{t('apps.f2Desc')}</span>
                </div>
              </div>
              <div className="feature-item">
                <i className="fa-solid fa-microphone-lines"></i>
                <div>
                  <strong>{t('apps.f3Title')}</strong>
                  <span>{t('apps.f3Desc')}</span>
                </div>
              </div>
              <div className="feature-item">
                <i className="fa-solid fa-moon"></i>
                <div>
                  <strong>{t('apps.f4Title')}</strong>
                  <span>{t('apps.f4Desc')}</span>
                </div>
              </div>
            </div>

            <div className="flagship-action">
              <a
                href="https://sacredlifex.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                <span>{t('apps.visitBtn')}</span>
                <i className="fa-solid fa-arrow-up-right-from-square"></i>
              </a>

              <button
                type="button"
                className="btn btn-secondary view-gallery-btn"
                onClick={() => onNavigate && onNavigate('gallery')}
              >
                <i className="fa-solid fa-images"></i>
                <span>{t('apps.viewGalleryBtn')}</span>
              </button>
            </div>
          </div>

          <div className="flagship-visual">
            <div className="app-phone-showcase">
              <div className="showcase-phone-device">
                <div className="showcase-top-bar">
                  <div className="showcase-speaker"></div>
                </div>
                <div className="showcase-screen-wrap">
                  <img
                    src={AppScreen1}
                    alt="SacredLifeX Ana Sayfa Ekranı"
                    className="showcase-app-img"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="showcase-bottom-bar">
                  <div className="showcase-home-bar"></div>
                </div>
              </div>
              <div className="showcase-badge-pill" onClick={() => onNavigate && onNavigate('gallery')}>
                <i className="fa-solid fa-expand"></i>
                <span>{t('apps.showcasePill')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming Pipeline */}
      <div className="pipeline-header">
        <div className="pipeline-title-box">
          <h3>{t('apps.pipelineTitle')}</h3>
          <span className="pipeline-badge">{t('apps.pipelineBadge')}</span>
        </div>
        <p>{t('apps.pipelineDesc')}</p>
      </div>

      <div className="upcoming-grid">
        {upcomingSlots.map((item) => (
          <div key={item.id} className="upcoming-card coming-soon-card">
            <div className="upcoming-top">
              <span className="upcoming-tag"><i className="fa-solid fa-hourglass-half"></i> {t('apps.rdTag')}</span>
              <span className="badge-soon">{t('apps.comingSoonBadge')}</span>
            </div>
            <h4 className="coming-soon-title">{t('apps.comingSoonTitle')}</h4>
            <p className="coming-soon-desc">{t('apps.comingSoonDesc')}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Applications;
